import axios from '@/services/httpClient';
import { useAuthStore } from '../stores/authStore';

//2025-1-12

export const getAuditTrails = async (startDate, endDate, retryAttempt = false) => {
    const authStore = useAuthStore();
    try {
        const response = await axios.get('/nora_superadmin/audit_trails', {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`
            },
            params: {
                start_date: startDate,
                end_date: endDate
            }
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            await authStore.refreshAccessToken();
            return getAllOrgArray(true); // Retry after refreshing
        }
        throw error;
    }
};

